import React, { FunctionComponent, ChangeEvent } from "react";
import { StandardTextFieldProps, TextField } from "@material-ui/core";

export interface INumberFieldProps extends StandardTextFieldProps {
  onChangeNumber: (value: number | null) => void;
}

export const NumberField: FunctionComponent<INumberFieldProps> = (props) => {
  const { onChange, onChangeNumber, ...rest } = props;

  const onCustomChange = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    onChange && onChange(e);
    const value = e.target.value;
    const numberValue = !value && !isNaN(Number(e.target.value)) ? null : Number(e.target.value);
    onChangeNumber && onChangeNumber(numberValue);
  };

  return <TextField {...rest} type="number" onChange={onCustomChange} />;
};
